import type {ConferenceApiModel} from '../../../api/conference';

import {getEntityTypeById} from '../getEntityType';

export const isConference = (entity: any): entity is ConferenceApiModel =>
  getEntityTypeById(entity?._id) === 'conference';
